import { render, staticRenderFns } from "./VeterinaryMedications.vue?vue&type=template&id=3c0c799c&scoped=true"
import script from "./VeterinaryMedications.vue?vue&type=script&lang=js"
export * from "./VeterinaryMedications.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryMedications.vue?vue&type=style&index=0&id=3c0c799c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c799c",
  null
  
)

export default component.exports